import React, { useState } from 'react';
import { decodeImportString, getPayloadSummary, createTextsImportString } from '../utils/importFormat';

export default function ImportExport({ t }) {
  const [importStr, setImportStr] = useState('');
  const [payload, setPayload] = useState(null);
  const [exportStr, setExportStr] = useState('');
  const [copied, setCopied] = useState(false);

  const handleImportChange = (value) => {
    setImportStr(value);
    if (value.trim().length > 10) {
      const decoded = decodeImportString(value);
      setPayload(decoded);
      if (decoded) setExportStr(value.trim());
    } else {
      setPayload(null);
    }
  };

  const handleDecode = () => {
    const decoded = decodeImportString(importStr);
    setPayload(decoded);
    if (decoded) setExportStr(importStr.trim());
  };

  const handleCopyExport = () => {
    if (!exportStr) return;
    navigator.clipboard.writeText(exportStr);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleDeleteMessage = (index) => {
    if (!payload?.data?.messages) return;
    const newMessages = payload.data.messages.filter((_, i) => i !== index);
    setPayload({ ...payload, data: { ...payload.data, messages: newMessages } });
    setExportStr(createTextsImportString(newMessages));
  };

  const summary = payload ? getPayloadSummary(payload) : null;

  return (
    <div>
      <div style={{ marginBottom: '16px' }}>
        <label className="wow-label">{t.importLabel}</label>
        <textarea
          className="wow-textarea"
          rows={4}
          placeholder={t.importPlaceholder}
          value={importStr}
          onChange={e => handleImportChange(e.target.value)}
        />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <button className="wow-btn" onClick={handleDecode}>{t.importBtn}</button>
      </div>

      <div className="wow-separator" />

      <label className="wow-label">{t.previewLabel}</label>
      {!summary ? (
        <p style={{ color: 'var(--wow-text-muted)' }}>{t.noData}</p>
      ) : (
        <div style={{ marginBottom: '16px' }}>
          <div style={{ color: 'var(--wow-gold)', marginBottom: '8px' }}>
            {t.type}: <strong>{summary.type}</strong>
            {summary.name && <> — {summary.name}</>}
          </div>

          {payload.data?.messages && (
            <div>
              <div style={{ color: 'var(--wow-text-muted)', fontSize: '12px', marginBottom: '4px' }}>
                {t.messages}: {payload.data.messages.length}
              </div>
              {payload.data.messages.map((msg, index) => (
                <div key={index} className="wow-text-item">
                  <span style={{ color: 'var(--wow-text-muted)', minWidth: '28px', fontSize: '12px' }}>#{index + 1}</span>
                  <span style={{ flex: 1, fontSize: '14px', color: 'var(--wow-text)' }}>{msg}</span>
                  <button className="wow-btn wow-btn-danger" style={{ padding: '2px 8px', fontSize: '12px' }} onClick={() => handleDeleteMessage(index)}>✕</button>
                </div>
              ))}
            </div>
          )}

          {payload.data?.children && (
            <div>
              <div style={{ color: 'var(--wow-text-muted)', fontSize: '12px', marginBottom: '4px' }}>
                {t.textGroups}: {payload.data.children.length}
              </div>
              {payload.data.children.map((child, i) => (
                <div key={i} className="wow-text-item">
                  <strong style={{ color: 'var(--wow-gold)' }}>{child.name}</strong>
                  <span style={{ color: 'var(--wow-text-muted)' }}> — {child.messages?.length || 0} {t.messages}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <div className="wow-separator" />

      <div style={{ marginBottom: '8px' }}>
        <label className="wow-label">{t.exportLabel}</label>
        <textarea
          className="wow-textarea"
          rows={3}
          readOnly
          placeholder={t.exportPlaceholder}
          value={exportStr}
        />
      </div>
      <button className="wow-btn" onClick={handleCopyExport} disabled={!exportStr}>
        {copied ? '✓' : t.copyBtn}
      </button>
    </div>
  );
}
